import { render } from "./CustomGantt.vue?vue&type=template&id=348fbd10&scoped=true"
import script from "./CustomGantt.vue?vue&type=script&lang=js"
export * from "./CustomGantt.vue?vue&type=script&lang=js"

import "./CustomGantt.vue?vue&type=style&index=0&id=348fbd10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348fbd10"]])

export default __exports__